import './_ConfigureDataFeed.scss';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik, Form as FormikForm, FormikProps } from 'formik';
import { Card, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import Alert from '../../../../ntisui/Atoms/Alerts';
import Button from '../../../../ntisui/Atoms/Buttons';
// import DataFeedModal from '../../molecules/DataFeedModal';
import DataFeedForm from '../../molecules/DataFeedForm';
import { ButtonVariant } from '../../../template/types/IHeader';
import { litrals } from '../../../../../constants/Litrals';
import { feedConstants } from '../../../../../constants/DataFeed';
import { format } from 'date-fns';
import {
  IFormValues,
  IFormProps,
  IHistory,
  //   IFeed,
  AlertType,
  ActionType,
} from '../types/IConfigureDataFeed';
import {
  getData,
  postData,
  updateData,
} from '../../../../../api/ApiCommunication';
import ConfigureDataFeedValidationSchema from './ConfigureDataFeedValidationSchema';
import { breadcrumbsLinks } from '../../../../../constants/Constants';
import Breadcrumbs from '../../../../ntisui/Atoms/Breadcrumb';
import useToastContext from '../../../../App/hooks/useToastContext';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ConfigureDataFeed: React.FC<IFormProps> = ({}: IFormProps) => {
  const history = useHistory<IHistory>();
  const feed = history.location.state.data;
  const action = history.location.state.action;
  const key = feed.subscriptionId;
  //   const [showModal, setShowModal] = useState(false);
  //   const [modalData, setModaldata] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isAlert, setIsAlert] = useState('');
  const [isLoading, setIsLoading] =
    action != ActionType.Edit ? useState(false) : useState(true);
  const [formValues, setFormValues] = useState({
    endpointUrl: '',
    endpointUsername: '',
    endpointPassword: '',
    isDataFeedEnabled: true,
    createdDate: '',
    lastUpdatedDate: '',
    subscriptionFeedTypeID: '',
    selectedAreas: [],
  });
  const [selectedAreas, setSelectedAreaOptions] = useState([]);
  const [updateSelectedAreas, setUpdateSelectedAreaOptions] = useState([]);

  const addToast = useToastContext();

  //   const handleModal = (info: IFeed) => {
  //     setShowModal(true);
  //     setModaldata(info);
  //   };
  const handleSubmit = async (values: any) => {
    console.log(values);
    const isEmpty =
      Object.values(formValues).every(
        (x) => x === null || x === '' || x === true,
      ) && updateSelectedAreas.length > 0;
    if (isEmpty) {
      return;
    }
    setIsUpdate(true);
    const updatedData = {
      endpointUrl: values.endpointUrl,
      username: values.endpointUsername,
      password: values.endpointPassword,
      disabled: action === ActionType.Add ? true : !values.isDataFeedEnabled,
      subscriptionFeedTypeId:
        feed.subscriptionFeedTypeID || values.subscriptionFeedTypeID,
      areaId: updateSelectedAreas.map((item: any) => item.value),
    };

    const apiEndpoint =
      action === ActionType.Add ? 'addUserFeed' : 'updateUserFeed';

    try {
      action === ActionType.Edit
        ? await updateData(apiEndpoint, updatedData, `/${key}`)
        : await postData(apiEndpoint, updatedData);

      addToast({
        message:
          action === ActionType.Add
            ? 'Data feed is successfully configured'
            : litrals.alertSuccess,
        action: 'success',
      });

      history.push('/subscriberportal/subscriberdatafeed');
    } catch (error) {
      addToast({
        message:
          action === ActionType.Add
            ? 'Some error occurred, unable to configure your data feed'
            : litrals.alertError,
        action: 'error',
      });

      setIsAlert(AlertType.Error);
    }
  };

  const [areaListOptions, setAreaListOptions] = useState([]);

  useEffect(() => {
    const params = {
      subscriptionId: key,
    };
    async function fetchGetDataFeedByID() {
      await getData('getDataFeedByID', params).then((res) => {
        const {
          endpointUrl,
          userName,
          password,
          disabled,
          createdAtDateTime,
          updatedAtDateTime,
          subscriptionFeedTypeId,
          area,
        } = res.data?.data?.subscriptions[0];
        const transformedData = area?.map(
          (item: { areaName: any; areaID: any }) => ({
            label: item.areaName,
            value: item.areaID,
          }),
        );
        setFormValues({
          endpointUrl,
          endpointUsername: userName,
          endpointPassword: password,
          isDataFeedEnabled: disabled ? false : true,
          subscriptionFeedTypeID: subscriptionFeedTypeId,
          createdDate: createdAtDateTime
            ? format(new Date(createdAtDateTime), 'dd/MM/yyy hh:mm')
            : '',
          lastUpdatedDate: updatedAtDateTime
            ? format(new Date(updatedAtDateTime), 'dd/MM/yyy hh:mm')
            : '',
          selectedAreas: transformedData,
        });
        setUpdateSelectedAreaOptions(transformedData);
        setSelectedAreaOptions(transformedData);
        setIsLoading(false);
      });
    }
    action == ActionType.Edit && fetchGetDataFeedByID();

    //get area of interest list
    async function fetchGetDataAreaofInterest() {
      await getData('getAreaList', params).then((res) => {
        const transformedData = res.data?.data.map(
          (item: { areaName: any; areaID: any }) => ({
            label: item.areaName,
            value: item.areaID,
          }),
        );
        setAreaListOptions(transformedData);
      });
    }
    fetchGetDataAreaofInterest();
  }, []);

  const [addAOI, setAddAOI] = useState(false);

  const handleSelectChange = (event: any, item: any) => {
    if (!item) {
      return;
    }
    let updatedSelectedAreas: Array<any> = [...selectedAreas];
    let isSelectEntireNetworkSelected = false;

    if (item.label === 'Select entire network' && event.target.checked) {
      // If "Select entire network" is checked, uncheck all other options
      updatedSelectedAreas = [];
      updatedSelectedAreas.push(item);
      isSelectEntireNetworkSelected = true;
    } else if (
      item.label === 'Select entire network' &&
      !event.target.checked
    ) {
      // If "Select entire network" is unchecked, enable all other options
      updatedSelectedAreas = [];
      isSelectEntireNetworkSelected = true;
    } else {
      // If another option is checked or "Select entire network" is unchecked
      if (event.target.checked) {
        updatedSelectedAreas.push(item);
      } else {
        const index = updatedSelectedAreas.findIndex(
          (selected) => selected.value === item.value,
        );
        if (index !== -1) {
          updatedSelectedAreas.splice(index, 1);
        }
      }
    }

    const updatedOptions = areaListOptions.map((option) => ({
      ...option,
      isDisabled:
        isSelectEntireNetworkSelected &&
        option.label !== 'Select entire network',
    }));

    if (updatedSelectedAreas.length > 20) {
      addToast({
        message: `Maximum 20 Areas of interest you can select at most.`,
        action: 'error',
      });
      return;
    }

    setSelectedAreaOptions(updatedSelectedAreas);
    setAreaListOptions(updatedOptions);
  };

  return (
    <Row
      className="configuredata-feed-container"
      data-testid="configuredatafeed-feed-container"
    >
      {!isLoading || action == ActionType.Add ? (
        <Container>
          <Breadcrumbs
            links={
              action == ActionType.Add
                ? [
                    ...breadcrumbsLinks.configureSubscriberFeed,
                    { name: `Configure ${feed.feedTypeName}`, url: '' },
                  ]
                : [
                    ...breadcrumbsLinks.editSubscriberFeed,
                    { name: `Edit ${feed.feedTypeName}`, url: '' },
                  ]
            }
          />

          <Row>
            <Col md={{ span: 6 }} className="inner-container">
              {isAlert ? (
                <Alert
                  message={
                    isAlert == AlertType.Success
                      ? litrals.alertSuccess
                      : litrals.alertError
                  }
                  alert={isAlert}
                />
              ) : (
                ''
              )}
              <h4 className="section-heading">
                {action == ActionType.Add
                  ? feedConstants.feedPageTitle
                  : feedConstants.editDataFeedTitle}
              </h4>

              <p className="content-paragraph">{litrals.dataFeedsDelivered}</p>

              <Formik
                validationSchema={ConfigureDataFeedValidationSchema}
                onSubmit={handleSubmit}
                initialValues={(formValues || {}) as any}
                enableReinitialize={true}
              >
                {({ handleSubmit }: FormikProps<IFormValues>) => (
                  <FormikForm>
                    <DataFeedForm
                      feed={feed}
                      //   handleModal={handleModal}
                      actionType={action}
                      isUpdate={isUpdate}
                    />
                    <Form.Group controlId="areasOfInterest">
                      <Card className="areasofinterest mt-4">
                        {!addAOI ? (
                          <Col md={12}>
                            <Row>
                              <Col md={6} className="heading">
                                <Card.Text className="form-card-text bold">
                                  Areas of interest
                                </Card.Text>
                              </Col>
                              <Col className="d-flex ml-auto">
                                <Button
                                  variant={ButtonVariant.Primary}
                                  className="button-aoi"
                                  onClick={() => setAddAOI(!addAOI)}
                                  label="+ Add areas of interests"
                                />
                              </Col>
                            </Row>
                            <div className="mt-4">
                              <p className="subheading">Areas selected</p>
                              {updateSelectedAreas.length ? (
                                <Row className="gap-3 pl-5">
                                  {updateSelectedAreas.map((item) => {
                                    return (
                                      <div
                                        key={item.label}
                                        className="selectedAreaBadges"
                                      >
                                        {item.label}
                                        <span
                                          className="cursor-pointer"
                                          onClick={() => {
                                            const removeAreas: Array<any> = [
                                              ...updateSelectedAreas,
                                            ];
                                            const index = removeAreas.findIndex(
                                              (selected) =>
                                                selected.value === item.value,
                                            );
                                            if (index !== -1) {
                                              removeAreas.splice(index, 1);
                                            }
                                            setSelectedAreaOptions(removeAreas);
                                            setUpdateSelectedAreaOptions(
                                              removeAreas,
                                            );
                                          }}
                                        >
                                          x
                                        </span>
                                      </div>
                                    );
                                  })}
                                </Row>
                              ) : (
                                <p className="placeholder-aoi">
                                  Selected areas of interest will be shown here.
                                </p>
                              )}
                            </div>
                          </Col>
                        ) : (
                          <Col md={12} className="d-flex flex-column gap-4">
                            <Row>
                              <Col md={6} className="heading">
                                <Card.Text className="form-card-text bold">
                                  Add areas of interest
                                </Card.Text>
                              </Col>
                              <Col>
                                <FontAwesomeIcon
                                  className="subheader-mobile-toggle-icon d-flex ml-auto cursor-pointer"
                                  icon={faTimes as IconProp}
                                  title="close-icon"
                                  onClick={() => {
                                    setSelectedAreaOptions(updateSelectedAreas);
                                    setAddAOI(false);
                                  }}
                                />
                              </Col>
                            </Row>
                            <p className="placeholder-aoi">
                              Please select your required cities, up to a
                              maximum of 20.
                            </p>
                            <Col md={12}>
                              <ul
                                aria-controls="areasOfInterest"
                                className="list-group aoi-options-container thin-scrollbar"
                              >
                                {areaListOptions.map((item) => {
                                  return (
                                    <li
                                      key={item.label}
                                      className="list-group-item d-flex gap-4 border-0 pl-0 "
                                    >
                                      <input
                                        name="areasOfInterest"
                                        className="form-check-input me-1"
                                        type="checkbox"
                                        value={item.value}
                                        aria-label={item.label}
                                        checked={selectedAreas.some(
                                          (selected) =>
                                            selected.value === item.value,
                                        )}
                                        onChange={(e: any) =>
                                          handleSelectChange(e, item)
                                        }
                                        disabled={
                                          item.label !=
                                            'Select entire network' &&
                                          selectedAreas.some(
                                            (selected: any) =>
                                              selected.label ===
                                              'Select entire network',
                                          )
                                        }
                                      />
                                      {item.label}
                                    </li>
                                  );
                                })}
                              </ul>
                            </Col>
                            <Row>
                              <Col md={2}>
                                <Button
                                  variant={ButtonVariant.Primary}
                                  className="button-aoi"
                                  onClick={() => {
                                    setUpdateSelectedAreaOptions(selectedAreas);
                                    setAddAOI(false);
                                  }}
                                  label="Done"
                                />
                              </Col>
                              <Col md={2}>
                                <Button
                                  variant={ButtonVariant.OutlinePrimary}
                                  className="button-aoi"
                                  onClick={() => {
                                    setSelectedAreaOptions(updateSelectedAreas);
                                    setAddAOI(false);
                                  }}
                                  label="Cancel"
                                />
                              </Col>
                            </Row>
                          </Col>
                        )}
                      </Card>
                    </Form.Group>
                    <div className="info-message-tooltip m-top-1-6">
                      <i className="fa fa-info-circle" aria-hidden="true"></i>
                      <p className="m-left-1">
                        {feedConstants.prePrivacyNoticeLinkText}
                        <a
                          target="_blank"
                          className="form-link"
                          href={feedConstants.privacyNoiceUrl}
                        >
                          {feedConstants.privacyNoticeLinkText}
                        </a>
                      </p>
                    </div>

                    <h5 className="usage-policy-heading">
                      {feedConstants.acceptableUsagePolicyTitle}
                    </h5>
                    <div className="form-text-information m-left-0-4">
                      <p className="content-paragraph m-left-1">
                        {feedConstants.preAcceptablePolicyLinkText}
                        <a
                          className="form-link"
                          target="_blank"
                          href={feedConstants.acceptablePolicyUrl}
                        >
                          {feedConstants.acceptablePolicyLinkText}
                        </a>
                      </p>
                    </div>
                    <div className="save-feed-button-container">
                      <Button
                        variant={ButtonVariant.Primary}
                        className="save-feed-button"
                        onClick={handleSubmit}
                        label={feedConstants.saveFeedButtonText}
                      />
                    </div>
                  </FormikForm>
                )}
              </Formik>
              {/* {showModal && (
                <DataFeedModal
                  onClose={() => setShowModal(false)}
                  show={showModal}
                  title={modalData?.feedTypeName}
                  content={
                    action == ActionType.Add
                      ? modalData?.description
                      : modalData?.dataFeedDescription
                  }
                />
              )} */}
            </Col>
          </Row>
        </Container>
      ) : (
        <div className="d-flex justify-content-center text-center">
          <Spinner
            className="spinner-border"
            animation="border"
            role="status"
          />
        </div>
      )}
    </Row>
  );
};
export default ConfigureDataFeed;
